import React from 'react';
import * as PageErrorMessages from '../constants/pageErrorMessage'

const ErrorWrongApproach = () => {
  return(
    <div>
      {PageErrorMessages.SEARCH_WITH_WRONG_URL}
    </div>
  );
}

export default ErrorWrongApproach;
